// extracted by mini-css-extract-plugin
export default {"body":"body--QMW_7","main":"main--R4Xi0","clearPadding":"clearPadding--U_BHK","fullWidth":"fullWidth--PcqAp","side":"side--m7DJA"};